import React from "react";
import { string, func, arrayOf, shape, bool } from "prop-types";
import { twMerge } from "tailwind-merge";

import { withTabNavigation } from "@hoc/withTabNavigation";

const ListItem = withTabNavigation("li");

const ItemSelector = ({ items, value, onClickItem, isDisabled }) => {
  const handleChange = selectedItemValue => {
    if (isDisabled) {
      return;
    }

    onClickItem?.(selectedItemValue);
  };

  return (
    <ul className="flex justify-start list-none m-0 gap-2">
      {items.map(item => {
        const isSelected = value === item.value;

        return (
          <ListItem
            className={twMerge(
              "inline-block px-2 py-1 transition duration-300 rounded-sm max-smallMobile:px-1",
              isSelected
                ? "text-white bg-primaryDark"
                : "text-primaryDarkAccent",
              !isSelected && !isDisabled
                ? "hover:bg-primaryDarkAccent/10 hover:duration-150 cursor-pointer"
                : "cursor-default"
            )}
            key={item.value}
            onClick={() => handleChange(item.value)}
          >
            <span
              onClick={() => handleChange(item.value)}
              className="block m-0 max-smallMobile:text-xs/4 text-sm/4 uppercase tracking-px font-semibold whitespace-nowrap transition duration-300"
            >
              {item.title}
            </span>
          </ListItem>
        );
      })}
    </ul>
  );
};

ItemSelector.propTypes = {
  items: arrayOf(
    shape({
      value: string,
      title: string,
    })
  ).isRequired,
  value: string,
  onClickItem: func,
  isDisabled: bool,
};

export default ItemSelector;
